<lib-modal
    [title]="'my-tasks.location-check-modal'"
    [componentID]="'location-check-modal'"
>
    <p>{{ 'my-tasks.location-check-modal-text' | translate }}</p>
    <p>
        <i class="fa fa-map-marker map-icon"></i>
        <strong>{{ 'my-tasks.location-address' | translate }}: </strong>
        <span *ngIf="address">{{ this.address }}</span>
    </p>
    <div>
        <div class="map-container" #mapContainer>
            <google-map
                [center]="center"
                [zoom]="zoom"
                [options]="mapOptions"
                [height]="400"
                [width]="320"
            >
                <map-marker
                    *ngFor="let marker of markers"
                    [position]="marker"
                ></map-marker>
            </google-map>
        </div>
    </div>

    <div class="btn-toolbar justify-content-between text-center mt-2">
        <div class="btn-group m-auto">
            <button class="btn btn-success" (click)="acceptLocation()">
                <i class="fa fa-check"></i>{{ 'my-tasks.accept-location' | translate }}
            </button>
            <button class="btn btn-danger" (click)="closeModal()">
                <i class="fa fa-undo"></i>{{ 'my-tasks.decline-location' | translate }}
            </button>
        </div>
    </div>
</lib-modal>
